import React from 'react';
import CTASection from '../components/CTASection';
import Reveal from '../components/Reveal';
import { products, routeHref } from '../data/siteData';

const ProductsPage = () => {
  return (
    <main>
      <section className="page-heading">
        <div className="container-custom">
          <Reveal>
            <p className="eyebrow-pill mb-5">Products</p>
            <h1 className="page-title">A coconut export catalogue for importers and bulk buyers.</h1>
            <p className="page-intro">
              Product discussions stay practical: intended use, destination market, expected volume, packaging requirement, quality expectation, and shipment timeline.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="page-section">
        <div className="container-custom">
          <Reveal>
            <div className="catalogue-intro">
              <span>Buyer catalogue</span>
              <p>Each product section is structured for trade decisions: what it is, who it serves, how it can be packed, and what quality conversation should happen before confirmation.</p>
            </div>
          </Reveal>

          <div className="product-editorial-list mt-14">
            {products.map((product, index) => (
              <Reveal key={product.name} delay={index * 60}>
                <article className="product-editorial">
                  <div className="product-editorial-image">
                    <img src={product.image} alt={`${product.name} for export supply`} />
                  </div>
                  <div className="product-editorial-copy">
                    <span>{String(index + 1).padStart(2, '0')}</span>
                    <h2>{product.name}</h2>
                    <p>{product.description}</p>

                    <div className="product-spec-grid">
                      <div>
                        <strong>Key features</strong>
                        <ul>
                          {product.features.map((feature) => (
                            <li key={feature}>{feature}</li>
                          ))}
                        </ul>
                      </div>
                      <div>
                        <strong>Suitable buyers</strong>
                        <p>{product.buyers}</p>
                      </div>
                      <div>
                        <strong>Packaging note</strong>
                        <p>{product.packaging}</p>
                      </div>
                      <div>
                        <strong>Quality note</strong>
                        <p>{product.quality}</p>
                      </div>
                    </div>

                    <a href={routeHref('/contact')} className="text-link">Request quote and specification</a>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTASection
        eyebrow="Product inquiry"
        title="Need a product matched to your market, packaging, and volume?"
        text="Send your requirement with destination, quantity, and preferred product format so the response can focus on the details that matter to your buying team."
        primaryLabel="Request Product Details"
        secondaryLabel="View Export Process"
        secondaryPath="/process"
      />
    </main>
  );
};

export default ProductsPage;
